import { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface MetricCardProps {
  title: string
  value: string
  description: string
  icon: LucideIcon
  tone?: 'teal' | 'amber' | 'rose' | 'slate' | 'emerald'
  className?: string
}

const toneMap = {
  teal: 'from-teal-500/20 to-teal-900/50 text-teal-400',
  amber: 'from-amber-400/20 to-amber-900/50 text-amber-400',
  rose: 'from-rose-400/20 to-rose-900/50 text-rose-400',
  slate: 'from-slate-400/20 to-slate-800/50 text-slate-300',
  emerald: 'from-emerald-400/20 to-emerald-900/50 text-emerald-400',
}

export function MetricCard({
  title,
  value,
  description,
  icon: Icon,
  tone = 'teal',
  className,
}: MetricCardProps) {
  return (
    <article className={cn("rounded-[28px] border border-stone-800 bg-[#141414] p-5 shadow-xl backdrop-blur", className)}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-medium text-stone-400">{title}</p>
          <p className="mt-3 text-3xl font-semibold text-white">{value}</p>
          <p className="mt-2 text-sm leading-6 text-stone-500">{description}</p>
        </div>
        <div
          className={cn(
            'flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br',
            toneMap[tone],
          )}
        >
          <Icon className="h-5 w-5" />
        </div>
      </div>
    </article>
  )
}
